/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Subtitle_Extract_Event_CountInputs */



/**
* | output |
* | --- |
* | "Events: {count}" |
*
* @param {Subtitle_Extract_Event_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_event_count = /** @type {((inputs: Subtitle_Extract_Event_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Event_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Événements : ${i?.count}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ereignisse: ${i?.count}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Eventi: ${i?.count}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`События: ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Eventos: ${i?.count}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`事件：${i?.count}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント: ${i?.count}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`घटनाएँ: ${i?.count}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Eventos: ${i?.count}`)
	return /** @type {LocalizedString} */ (`Events: ${i?.count}`)
});